/* eslint-disable */
export default {
  unknown: 'Sconosciuto',
  multipleMatches: 'Corrispondenze multiple',
  anonymous: 'Numero anonimo',
  none: 'Nessuno',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"multipleMatches"@#@ @source: @#@"Multiple matches"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"none"@#@ @source: @#@"None"@#@
